import { fonts } from './definitions';
import { FontDefinitionDefault } from './defaults';
import { defaultsDeep } from 'lodash-es';
import { BASE_FONTS } from '@routes/event/create/DesignDemo/constants';

type FontSizes = 'h1' | 'h2' | 'h3' | 'h4' | 'hero' | 'subhero' | 'body';

export type FontDefinitions = { [index in FontSizes]: any };

type Format = 'desktop' | 'mobile';

export const textTransformFonts = ['Josefin Sans', 'Fjalla One', 'Gudea'];

export const supportedFontFamily = (font: string) => {
  if (!BASE_FONTS[font]) {
    return BASE_FONTS['Proxima Nova'];
  }

  return BASE_FONTS[font];
};

export const loadFont = (font: string) => {
  const fontFamilies = [supportedFontFamily(font)];
  window.WebFont.load({
    google: {
      families: fontFamilies
    }
  });
};

const createValue = (val: Object, modifier: number) => {
  return Object.keys(val).reduce((acc, curr) => {
    if (val[curr].value && val[curr].unit) {
      // TODO: Remove modifier and redo font defs
      return {
        ...acc,
        [curr]: val[curr].unit === 'text' ? `${val[curr].value}` : `${val[curr].value * modifier}${val[curr].unit}`
      };
    } else if (val[curr].unit) {
      // for texttransform
      return {
        ...acc,
        [curr]: `${val[curr].unit}`
      };
    } else {
      return acc;
    }
  }, {});
};

const createDefinition = (font: string, format: string, modifier: number) => {
  const fontFamilyMatch = supportedFontFamily(font);
  const storedFontDefinition = fonts[fontFamilyMatch];
  const def = storedFontDefinition
    ? defaultsDeep(storedFontDefinition[format], FontDefinitionDefault)
    : FontDefinitionDefault;
  return Object.keys(def).reduce((acc, curr) => {
    return { ...acc, [curr]: createValue(def[curr], modifier) };
  }, {});
};

export const fontService = (font: string, format: Format, modifier: number = 2): FontDefinitions => {
  return createDefinition(font, format, modifier) as FontDefinitions;
};
